const DEFAULT_APP_LANGUAGE = 'en';
const APP_LANGUAGE_STORAGE_KEY = 'app.language';

const LANGUAGE_OPTIONS = Object.freeze([
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'or', label: 'ଓଡ଼ିଆ' },
  { code: 'bn', label: 'Bengali' },
]);

const SUPPORTED_LANGUAGE_CODES = new Set(LANGUAGE_OPTIONS.map((option) => option.code));

const normalizeLanguageCode = (value) => {
  if (!value) return DEFAULT_APP_LANGUAGE;

  const normalized = String(value).toLowerCase().trim();
  if (SUPPORTED_LANGUAGE_CODES.has(normalized)) return normalized;

  const baseLanguage = normalized.split('-')[0];
  if (SUPPORTED_LANGUAGE_CODES.has(baseLanguage)) return baseLanguage;

  return DEFAULT_APP_LANGUAGE;
};

const getStoredAppLanguage = () => {
  if (typeof window === 'undefined') return DEFAULT_APP_LANGUAGE;

  try {
    const storedLanguage = window.localStorage.getItem(APP_LANGUAGE_STORAGE_KEY);
    if (storedLanguage) return normalizeLanguageCode(storedLanguage);

    const browserLanguage = window.navigator?.language || window.navigator?.languages?.[0];
    return normalizeLanguageCode(browserLanguage);
  } catch (error) {
    return DEFAULT_APP_LANGUAGE;
  }
};

const setStoredAppLanguage = (language) => {
  const normalizedLanguage = normalizeLanguageCode(language);

  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(APP_LANGUAGE_STORAGE_KEY, normalizedLanguage);
    } catch (error) {
      // Ignore storage write errors and keep app functional.
    }
  }

  return normalizedLanguage;
};

const applyLanguageToDocument = (language) => {
  if (typeof document === 'undefined') return;

  const normalizedLanguage = normalizeLanguageCode(language);
  const documentLanguage = normalizedLanguage === 'or' ? 'or-IN' : `${normalizedLanguage}-IN`;

  document.documentElement.lang = documentLanguage;
  document.documentElement.setAttribute('data-app-language', normalizedLanguage);
};

export {
  DEFAULT_APP_LANGUAGE,
  APP_LANGUAGE_STORAGE_KEY,
  LANGUAGE_OPTIONS,
  normalizeLanguageCode,
  getStoredAppLanguage,
  setStoredAppLanguage,
  applyLanguageToDocument,
};
